import { scaleSqrt } from "d3-scale";

export function pyramidSort(children){
  let sortedChildren = children.sort((a, b) => a.value - b.value)
  let left = sortedChildren.filter((v, i) => i % 2 === 0)
  let right = sortedChildren.filter((v, i) => i % 2 === 1)
  let pyramidSortedChildren = left.concat(right.reverse())
  return pyramidSortedChildren
}

/** Dispatch event on click outside of node */
export function clickOutside(node) {
    const handleClick = (event) => {
      if (node && !node.contains(event.target) && !event.defaultPrevented) {
        node.dispatchEvent(new CustomEvent("click_outside", node));
      }
    };
  
    document.addEventListener("click", handleClick, true);
  
    return {
      destroy() {
        document.removeEventListener("click", handleClick, true);
      },
    };
  }

  export function cactulate(tree, options) {
    const maxleaves = tree.value;
    const sizeScale = scaleSqrt()
      .domain([0, maxleaves])
      .range([0, options.maxR]);

    tree.x = 0;
    tree.y = 0;
    tree.r = options.rootR;
    tree.rot = options.rootRotation;
    tree.cumvalue = 1;

    tree.each(function (node) {
      //For all nodes, except the root node
      if (node.depth != 0) {
        //If the node has no children, it is a leaf, and it should get the leafR as the radius
        if (!node.children) {
          node.r = options.leafR;
        }
        //If the node has children
        else {
          node.r =
            sizeScale(node.value) * Math.pow(options.scaleFactor, node.depth);
        }

        let childrenNumber = node.parent.children.length - 1;
        //If the node is an only child, it should inherit its rotation from its parent
        if (childrenNumber == 0) {
          node.rot = node.parent.rot;
        }
        //If there are more than 1 child
        else {
          //The rotation of the first level nodes determines in what angles the branches grow
          if (node.depth == 1) {
            node.rot =
              (Math.PI + 2 * options.extraAngle) * node.cumvalue +
              node.parent.rot -
              (Math.PI / 2 + options.extraAngle);
          }
          //For other nodes we are using the branchAngle, instead of the extraAngle
          if (node.depth != 1) {
            node.rot =
              (Math.PI + 2 * options.branchAngle) * node.cumvalue +
              node.parent.rot -
              (Math.PI / 2 + options.branchAngle);
          }
          if (!node.children) {
            node.rot =
              (Math.PI + 2 * options.leafAngle) * node.cumvalue +
              node.parent.rot -
              (Math.PI / 2 + options.leafAngle);
          }
        }
        node.x =
          Math.cos(node.rot) *
            (node.parent.r + node.r * (1 - options.overlapFactor)) +
          node.parent.x;
        node.y =
          Math.sin(-node.rot) *
            (node.parent.r + node.r * (1 - options.overlapFactor)) +
          node.parent.y;
      }
    });

    let links = tree.links();

    // Coordinates for the paths
    let cactusLinks = tree.leaves().map(function (node) {
      let nodepath = node.path(tree);
      let path = [];
      nodepath.forEach(function (nd, ind) {
        let coords = {};
        let rand = Math.random();
        coords.x =
          ind == nodepath.length - 1
            ? nd.x + Math.cos(rand * 2 * Math.PI) * options.lineRootR
            : nd.x;
        coords.y =
          ind == nodepath.length - 1
            ? nd.y + Math.sin(rand * 2 * Math.PI) * options.lineRootR
            : nd.y;
        path.push(coords);
      });
      let ln = {};
      ln.parent = node.data.from
      ln.id = node.data.to
      ln.path = path;
      return ln;
    });

    //Organise output
    let cactusLeaves = [];
    let cactusBranches = [];
    if (options.nodes != "none") {
      tree.eachBefore(function (node) {
        let cactusNode = {};
        cactusNode.x = node.x;
        cactusNode.y = node.y;
        cactusNode.r = node.r;
        cactusNode.parent = node.data.from;
        cactusNode.id = node.data.to;
        cactusNode.depth = node.depth;
        if(node.data.type){
          cactusNode.type = node.data.type;
        }
        cactusNode.rotation = node.rot;
        if (!node.children) {
          cactusLeaves.push(cactusNode);
        } else {
          cactusBranches.push(cactusNode);
        }
      });
    }
    return {
      nodes: { leaves: cactusLeaves, branches: cactusBranches },
      links: cactusLinks,
    };
  }